import React from 'react';
import { Message } from '@fiverr-private/layout-types';
import MessageComponent from '../Message';

interface MessagesProps {
    messages: Message[];
}

/**
 * Display messages
 */
const Messages: React.FC<MessagesProps> = ({ messages = [] }) => {
    if (messages.length === 0) {
        return null;
    }

    return (
        <div className="layout-messages">
            {messages.map(({ type, value }, index) => (
                <MessageComponent key={index} type={type} value={value} />
            ))}
        </div>
    );
};

export default Messages;
